
import { Component, Vue, Emit } from 'vue-property-decorator';

@Component({
  props: ['value', 'disabled'],
})
export default class TimePicker extends Vue {
  public menu = false;

  @Emit()
  private input(val: string) {
    return val;
  }
}
